import { get, post } from '.';

export function FindInlinePostLead(id, options = {}) {
	return get<any>("/app/api/inline_post_leads/" + (id || 0).toString(), options);
}

export function PostToInlineCrm(options = {}) {
	return post<any>("/app/api/post_to_inline_crm", options);
}
